export default "__VITE_ASSET__CBNTRM0H__"